import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';

import { OMNI_THEME } from '@aiz-gl/omni-ui';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  OktaAuthEnv,
  provideOktaAuth,
  provideTokenManager,
} from './app.providers';
import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { environmentInterceptor } from './interceptors/environment.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { messageInterceptor } from './interceptors/message.interceptor';
import { tokenInterceptor } from './interceptors/token.interceptor';
import { DarkTheme } from './theme/dark.theme';
import { LightTheme } from './theme/light.theme';

export const appConfig = (oktaAuthEnv: OktaAuthEnv): ApplicationConfig => ({
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    {
      provide: OMNI_THEME,
      useValue: { light: LightTheme, dark: DarkTheme },
    },
    provideHttpClient(
      withInterceptors([
        environmentInterceptor,
        messageInterceptor,
        errorInterceptor,
        authInterceptor,
        tokenInterceptor,
      ]),
    ),
    provideOktaAuth(oktaAuthEnv),
    provideTokenManager(),
  ],
});
